"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

exports.__esModule = true;

var react_1 = __importDefault(require("react"));

require("./avatar.scss");

var nama_icon_1 = require("../nama-icon");

var AvatarSizes;

(function (AvatarSizes) {
  AvatarSizes["small"] = "small";
  AvatarSizes["default"] = "default";
  AvatarSizes["large"] = "large";
})(AvatarSizes = exports.AvatarSizes || (exports.AvatarSizes = {}));

var Avatar = function Avatar(_a) {
  var pic = _a.pic,
      size = _a.size,
      name = _a.name;
  return react_1["default"].createElement("div", {
    className: "nama-avatar " + size,
    title: name ? name : ''
  }, pic ? react_1["default"].createElement("img", {
    alt: "avatar pic",
    src: pic
  }) : react_1["default"].createElement(nama_icon_1.NamaIcon, {
    icon: "Profile",
    className: ""
  }));
};

exports.Avatar = Avatar;
Avatar.defaultProps = {
  size: AvatarSizes["default"]
};